/* REIDWOOD Trail Cinema — ported 1:1 from trail-cinema-mockup.html for Shopify.
   Same motion system; cart/search/product data now come from Shopify APIs. */
(function(){
'use strict';
try{ gsap.registerPlugin(ScrollTrigger, SplitText); }catch(e){}
history.scrollRestoration = 'manual';

const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));
const money = c => '$' + (c/100).toFixed(2);
const TPL = (document.body.className.match(/tpl-([a-z0-9_-]+)/) || [,''])[1];

/* ================= LENIS ================= */
/* if a vendor lib is blocked (ad-blocker, flaky network), fall back to native
   scrolling instead of throwing here and killing the cart wiring below */
let lenis;
try{
  lenis = new Lenis({ lerp: 0.09 });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(t => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
}catch(e){
  lenis = { on(){}, raf(){}, scrollTo(t, o){ try{ typeof t === 'number' ? window.scrollTo({ top: t, behavior: 'smooth' }) : t.scrollIntoView({ behavior: 'smooth' }); }catch(_){} } };
}

/* ================= TOAST ================= */
let toastT;
function toast(msg){
  const t = $('#toast'); if (!t) return;
  t.textContent = msg || '';
  t.classList.add('on'); clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove('on'), 2200);
}

/* ================= WIPE NAVIGATION (page loads hide behind the ink wipe) ================= */
const WIPE_LABELS = { index:'BASE CAMP', collection:'THE FIELD KIT', product:'GEAR', page:'REIDWOOD',
  blog:'FROM THE FIELD', article:'FROM THE FIELD', cart:'YOUR PACK', search:'SEARCH', 'list-collections':'THE KITS' };
(function wipeReveal(){
  let flagged = false; try{ flagged = !!sessionStorage.getItem('rw_wipe'); sessionStorage.removeItem('rw_wipe'); }catch(e){}
  const w = $('#wipe'); if (!w || !flagged) return;
  w.style.clipPath = 'inset(0 0 0 0)';
  const lb = $('#wipeLabel'); if (lb){ lb.textContent = WIPE_LABELS[TPL] || 'REIDWOOD'; lb.style.opacity = 1; }
  gsap.timeline({ delay: .05 })
    .to('#wipe .display', { opacity: 0, duration: .15 }, '+=.12')
    .to(w, { clipPath: 'inset(0 0 100% 0)', duration: .5, ease: 'power3.inOut' })
    .set(w, { clipPath: 'inset(100% 0 0 0)' });
})();
document.addEventListener('click', e => {
  const a = e.target.closest('a[href]');
  if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
  const href = a.getAttribute('href');
  if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
  const url = new URL(a.href, location.href);
  if (url.origin !== location.origin) return;
  if (url.pathname === location.pathname && url.hash){       // same-page anchor: smooth scroll
    const tgt = document.querySelector(url.hash);
    if (tgt){ e.preventDefault(); lenis.scrollTo(tgt, { offset: -60 }); }
    return;
  }
  if (url.pathname.startsWith('/checkout') || url.pathname.startsWith('/account')) return;
  e.preventDefault();
  try{ sessionStorage.setItem('rw_wipe', '1'); }catch(_){}
  const w = $('#wipe'), lb = $('#wipeLabel');
  if (!w || typeof gsap === 'undefined'){ location.assign(url.href); return; }
  if (lb){ lb.textContent = 'REIDWOOD'; lb.style.opacity = 0; }
  gsap.timeline()
    .to(w, { clipPath: 'inset(0% 0 0 0)', duration: .45, ease: 'power3.inOut' })
    .to('#wipe .display', { opacity: 1, duration: .2 }, '-=.2')
    .add(() => location.assign(url.href));
});

/* ================= CART (Shopify AJAX API) ================= */
let CART = null;
const drawer = $('#drawer'), ovl = $('#ovl'), packBtn = $('#packBtn');
function openDrawer(){ drawer && drawer.classList.add('show'); ovl && ovl.classList.add('show'); }
function closeDrawer(){ drawer && drawer.classList.remove('show'); ovl && ovl.classList.remove('show'); }
async function cartFetch(){
  try{ CART = await (await fetch('/cart.js')).json(); renderCart(); }catch(e){}
}
async function cartAdd(id, qty){
  id = +id; qty = qty || 1;
  /* stack onto an existing line instead of ever creating a duplicate row */
  const line = CART && CART.items && CART.items.find(i =>
    i.variant_id === id && (!i.properties || !Object.keys(i.properties).length));
  if (line){
    await cartChange(line.key, line.quantity + qty);
    openDrawer(); toast('Added to pack');
    if (window.RW_CAPT_AFTER_ADD){ window.RW_CAPT_AFTER_ADD(); window.RW_CAPT_AFTER_ADD = null; }
    return;
  }
  const r = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify({ id: id, quantity: qty }) });
  if (r.ok){ await cartFetch(); openDrawer(); toast('Added to pack');
    if (window.RW_CAPT_AFTER_ADD){ window.RW_CAPT_AFTER_ADD(); window.RW_CAPT_AFTER_ADD = null; } }
  else { const err = await r.json().catch(() => ({})); toast(err.description || 'Could not add that'); }
}
async function cartChange(key, qty){
  await fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }) });
  await cartFetch();
}
function renderCart(){
  if (!CART) return;
  if (packBtn) packBtn.textContent = 'Pack · ' + CART.item_count;
  const body = $('#dBody'), foot = $('#dFoot');
  if (!body || !foot) return;
  if (!CART.items.length){
    body.innerHTML = '<div class="d-empty"><div class="display">Pack is empty</div>Fix that. The trail does not wait.<br><br><a class="btn" href="/collections/all-gear">Shop the kit</a></div>';
    foot.innerHTML = '';
    updateShipBar(0);
    return;
  }
  const inCart = new Set(CART.items.map(i => i.product_id));
  const sugg = (window.RW_UPSELL || []).filter(u => !inCart.has(u.pid)).slice(0, 2);
  body.innerHTML = CART.items.map(i => `<div class="d-item">
      <img src="${i.image || ''}" alt="">
      <div class="inf">
        <div class="t">${i.product_title}</div>
        <div class="pr">${money(i.final_line_price)}${i.original_line_price > i.final_line_price ? ' <s style="opacity:.5">' + money(i.original_line_price) + '</s>' : ''}</div>
        <div class="qty"><button data-ck="${i.key}" data-cq="${i.quantity - 1}">−</button><span>${i.quantity}</span><button data-ck="${i.key}" data-cq="${i.quantity + 1}">+</button></div>
      </div>
      <button class="rm" data-ck="${i.key}" data-cq="0">Remove</button>
    </div>`).join('')
  + (CART.item_count === 1 ? '<div class="d-nudge">BOGO is waiting: add any one more item and the cheaper of the two goes 50% off.</div>' : '')
  + (sugg.length ? '<div class="d-up"><h6>Complete the pack</h6>' + sugg.map(u =>
      `<div class="pair-row"><img src="${u.img}" alt=""><a href="${u.u}">${u.t}</a><span class="pr">${money(u.p)}</span><button data-vid="${u.vid}" aria-label="Add">+</button></div>`).join('') + '</div>' : '');
  const save = CART.total_discount;
  foot.innerHTML = `
    <div class="d-line"><span>Subtotal</span><span>${money(CART.total_price + save)}</span></div>
    ${save ? '<div class="d-line save"><span>BOGO · 2nd item 50% off</span><span>−' + money(save) + '</span></div>' : ''}
    <div class="d-line"><span>Shipping</span><span>${CART.total_price >= 7500 ? 'FREE' : '$8.00'}</span></div>
    <div class="d-line total"><span>Total</span><span>${money(CART.total_price)}</span></div>
    <a class="btn" style="display:flex;justify-content:center" href="/checkout">Checkout</a>
    <div class="paynote"><span>VISA</span><span>MASTERCARD</span><span>AMEX</span><span>PAYPAL</span><span>APPLE PAY</span><span>SHOP PAY</span></div>
    <div class="d-note">Secure checkout · 30-day trail guarantee · Ships from the U.S.</div>`;
  updateShipBar(CART.total_price);
}
function updateShipBar(cents){
  const fill = $('#shipFill'), txt = $('#shipTxt');
  if (!fill || !txt) return;
  const pct = Math.min(1, cents / 7500);
  fill.style.transform = 'scaleX(' + pct + ')';
  txt.innerHTML = cents >= 7500 ? '<b>Free shipping unlocked.</b> Nice packing.'
    : cents > 0 ? 'You are <b>' + money(7500 - cents) + '</b> from free U.S. shipping ($8 flat until then)'
    : '$8 flat U.S. shipping · FREE over <b>$75</b>';
}
if (packBtn) packBtn.onclick = () => { renderCart(); openDrawer(); };
const dClose = $('#dClose'); if (dClose) dClose.onclick = closeDrawer;
if (ovl) ovl.onclick = closeDrawer;
if (drawer) drawer.addEventListener('click', e => {
  const b = e.target.closest('[data-ck]');
  if (b) cartChange(b.dataset.ck, +b.dataset.cq);
});
/* global quick add: any [data-vid] button anywhere (cards, pairs, packlists, journal) */
document.addEventListener('click', e => {
  const b = e.target.closest('button[data-vid]');
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  let qty = 1;
  if (b.id === 'pdpAdd'){ const q = $('#pdpQ'); qty = q ? Math.max(1, +q.textContent) : 1; }
  cartAdd(b.dataset.vid, qty);
}, true);
cartFetch();

/* ================= SAVES (localStorage, object list) ================= */
let saves = [];
try{ saves = JSON.parse(localStorage.getItem('rw_saves2') || '[]'); }catch(e){}
const savedHas = h => saves.some(s => s.h === h);
function paintHearts(){
  $$('.psave').forEach(b => b.classList.toggle('onn', savedHas(b.dataset.h)));
  const chip = $('#savedChip');
  if (chip){
    chip.style.display = saves.length ? '' : 'none';
    chip.textContent = 'Saved · ' + saves.length;
  }
}
document.addEventListener('click', e => {
  const b = e.target.closest('button.psave');
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  if (savedHas(b.dataset.h)) saves = saves.filter(s => s.h !== b.dataset.h);
  else saves.push({ h: b.dataset.h, t: b.dataset.t, img: b.dataset.img, p: b.dataset.p, u: b.dataset.u });
  try{ localStorage.setItem('rw_saves2', JSON.stringify(saves)); }catch(_){}
  paintHearts();
  toast(savedHas(b.dataset.h) ? 'Saved for later' : 'Removed from saved');
}, true);
const savedChip = $('#savedChip');
if (savedChip) savedChip.onclick = () => {
  const grid = $('#shopGrid'); if (!grid) return;
  grid.innerHTML = saves.map(s => `<a class="pc" href="${s.u}">
    <button class="psave onn" data-h="${s.h}" data-t="${s.t}" data-img="${s.img}" data-p="${s.p}" data-u="${s.u}" aria-label="Remove from saved">♥</button>
    <div class="im"><img src="${s.img}" loading="lazy" alt=""></div>
    <div class="in"><div class="t">${s.t}</div><div class="price">${s.p}</div></div></a>`).join('')
    || '<p style="color:#8F8873;padding:40px 0">Nothing saved yet.</p>';
  const sc = $('#shopCount'); if (sc) sc.textContent = saves.length + ' saved for later';
};
paintHearts();

/* ================= SEARCH (Shopify predictive) ================= */
const srch = $('#srch'), srchIn = $('#srchIn'), srchRes = $('#srchRes');
function openSearch(){ if (!srch) return; srch.classList.add('show'); srchIn.value = ''; srchRes.innerHTML = ''; const h = $('#srchHint'); if (h) h.style.display = ''; setTimeout(() => srchIn.focus(), 60); }
function closeSearch(){ srch && srch.classList.remove('show'); }
const navSearch = $('#navSearch'); if (navSearch) navSearch.onclick = openSearch;
const srchX = $('#srchX'); if (srchX) srchX.onclick = closeSearch;
if (srch) srch.addEventListener('click', e => { if (e.target === srch) closeSearch(); });
let srchT;
if (srchIn) srchIn.addEventListener('input', () => {
  const q = srchIn.value.trim();
  const h = $('#srchHint'); if (h) h.style.display = q ? 'none' : '';
  clearTimeout(srchT);
  if (!q){ srchRes.innerHTML = ''; return; }
  srchT = setTimeout(async () => {
    try{
      const r = await (await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')).json();
      const hits = (r.resources && r.resources.results && r.resources.results.products) || [];
      srchRes.innerHTML = hits.map(p => `<a class="srch-row" href="${p.url}">
          <img src="${p.image || p.featured_image && p.featured_image.url || ''}" alt="">
          <div class="t"><span class="ty">${p.type || ''}</span>${p.title}</div>
          <span class="pr">$${p.price}</span></a>`).join('')
        || '<div class="srch-hint" style="display:block">Nothing in the kit matches that. Try "fire" or "tent".</div>';
    }catch(e){}
  }, 180);
});
addEventListener('keydown', e => {
  if (e.key === 'Escape'){ closeSearch(); closeDrawer(); closeMenu(); }
  if (e.key === '/' && srch && !srch.classList.contains('show') && !/input|textarea/i.test(document.activeElement.tagName)){ e.preventDefault(); openSearch(); }
});

/* ================= MOBILE MENU + BACK TO TOP ================= */
const mburger = $('#mburger'), mmenu = $('#mmenu');
function closeMenu(){
  if (mmenu) mmenu.classList.remove('show');
  if (mburger){ mburger.classList.remove('open'); mburger.setAttribute('aria-expanded', 'false'); }
}
if (mburger && mmenu){
  mburger.onclick = () => {
    const open = !mmenu.classList.contains('show');
    mmenu.classList.toggle('show', open);
    mburger.classList.toggle('open', open);
    mburger.setAttribute('aria-expanded', String(open));
  };
  const mmClose = $('#mmClose'); if (mmClose) mmClose.onclick = closeMenu;
  mmenu.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
}
const toTop = $('#toTop');
if (toTop){
  addEventListener('scroll', () => toTop.classList.toggle('show', scrollY > 1400), { passive: true });
  toTop.onclick = () => lenis.scrollTo(0, { duration: .9 });
}

/* ================= ANNOUNCEMENT BAR / STICKY BUY / CAPTURE ================= */
const abarMsgs = $$('#abar span');
/* on phones keep ONE static, legible message (the flagship BOGO offer) instead of
   an 8.5px rotator a cold ad click can't read */
if (abarMsgs.length && !matchMedia('(max-width: 860px)').matches){
  let abarI = 0;
  setInterval(() => {
    abarMsgs[abarI].classList.remove('on');
    abarI = (abarI + 1) % abarMsgs.length;
    abarMsgs[abarI].classList.add('on');
  }, 4200);
}
/* sticky buy: on product pages the bar shows whenever the REAL buy button is
   off-screen — including on first paint, before any scroll (on phones the buy
   row starts below the fold, and paid traffic lands directly on the PDP). */
(function stickyBuyCtl(){
  const sb = $('#stickyBuy'); if (!sb || TPL !== 'product') return;
  const buy = $('#pdpAdd');
  if (!buy){ addEventListener('scroll', () => sb.classList.toggle('show', scrollY > 480), { passive: true }); return; }
  /* deterministic rect check (not IntersectionObserver): runs synchronously at boot
     so the bar is already up on first paint when the buy row starts below the fold */
  const upd = () => {
    const r = buy.getBoundingClientRect();
    sb.classList.toggle('show', r.bottom < 106 || r.top > innerHeight);
  };
  upd();
  addEventListener('scroll', upd, { passive: true });
  addEventListener('resize', upd, { passive: true });
})();
const captX = $('#captX'); if (captX) captX.onclick = () => $('#capt').classList.remove('show');
/* centred on desktop, so it behaves like a modal: click the dimmed page or hit
   Escape to dismiss (the dim is a box-shadow, so listen on the document) */
(function captDismiss(){
  const capt = $('#capt'); if (!capt) return;
  document.addEventListener('click', e => {
    if (!capt.classList.contains('show')) return;
    if (!matchMedia('(min-width: 861px)').matches) return;
    if (capt.contains(e.target)) return;
    capt.classList.remove('show');
  }, true);
  addEventListener('keydown', e => {
    if (e.key === 'Escape' && capt.classList.contains('show')) capt.classList.remove('show');
  });
})();
(function capture(){
  const capt = $('#capt'); if (!capt || TPL === 'cart') return;
  let shown = false; try{ shown = !!sessionStorage.getItem('rw_capt'); }catch(e){}
  if (shown) return;
  let fired = false;
  const fire = () => {
    if (fired) return; fired = true;
    try{ sessionStorage.setItem('rw_capt', '1'); }catch(_){}
    capt.classList.add('show');
  };
  if (TPL === 'product'){
    /* paid traffic lands here mid-decision — never interrupt the buy consideration.
       Show only at committed/leaving moments: 8s after a successful add, desktop
       exit-intent, or genuinely deep scroll. */
    window.RW_CAPT_AFTER_ADD = () => setTimeout(fire, 8000);
    document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0) fire(); });
    addEventListener('scroll', () => { if (scrollY > document.documentElement.scrollHeight * .7) fire(); }, { passive: true });
  } else {
    setTimeout(fire, 12000);
    addEventListener('scroll', () => { if (scrollY > document.documentElement.scrollHeight * .35) fire(); }, { passive: true });
  }
})();
const benchLink = $('#benchListLink');
if (benchLink) benchLink.onclick = e => { e.preventDefault(); const c = $('#capt'); if (c) c.classList.add('show'); };

/* ================= CURSOR / MAGNETIC / TILT / REVEALS ================= */
/* custom cursor removed: no #cur element, no mousemove/mouseover tracking */
function initMagnetic(){
  $$('.btn').forEach(b => {
    if (b.dataset.mag) return; b.dataset.mag = 1;
    b.addEventListener('mousemove', e => {
      const r = b.getBoundingClientRect();
      gsap.to(b, { x: (e.clientX - r.left - r.width/2) * .18, y: (e.clientY - r.top - r.height/2) * .3, duration: .4, ease: 'power2.out' });
    });
    b.addEventListener('mouseleave', () => gsap.to(b, { x: 0, y: 0, duration: .5, ease: 'elastic.out(1, .5)' }));
  });
}
function initTilt(){
  $$('.pc').forEach(c => {
    if (c.dataset.tilt) return; c.dataset.tilt = 1;
    c.addEventListener('mousemove', e => {
      const r = c.getBoundingClientRect();
      const rx = ((e.clientY - r.top) / r.height - .5) * -6;
      const ry = ((e.clientX - r.left) / r.width - .5) * 6;
      c.style.transform = 'translateY(-6px) perspective(700px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
    });
    c.addEventListener('mouseleave', () => { c.style.transform = ''; });
  });
}
/* NOTE: .pdp-info > * and .pdp-gal were removed from this list on purpose —
   they re-hid the product image, price and Add button after first paint until
   GSAP ran (a visible flash + delayed buy box on the exact page paid traffic
   lands on). The buy box must never depend on the animation stack. */
function initReveals(root){
  (root || document).querySelectorAll('.sec-head, .cat, .pc, .story-blk, .j-card, .j-entry, .bench, .deal, .n-form, .val, .acc, .prose p, .prose img').forEach((el, i) => {
    if (el.dataset.rv) return; el.dataset.rv = 1;
    el.classList.add('rv');
    gsap.to(el, { y: 0, opacity: 1, duration: .8, ease: 'expo.out', delay: (i % 4) * .05,
      scrollTrigger: { trigger: el, start: 'top 92%', once: true } });
  });
}
addEventListener('scroll', () => {
  const n = $('#nav'); if (n) n.classList.toggle('scrolled', scrollY > 80);
}, { passive: true });

/* ================= HOME: hero cinema + chapters ================= */
function initHome(){
  const heroPin = $('#heroPin'); if (!heroPin) return;
  const pin = { trigger: '#heroPin', start: 'top top', end: 'bottom bottom', scrub: true };
  gsap.timeline({ scrollTrigger: pin })
    .to('.hero-c', { yPercent: -26, opacity: 0, ease: 'none', duration: .34 }, 0)
    .to('#scrollCue', { opacity: 0, duration: .08 }, 0)
    .fromTo('#heroLine2', { opacity: 0, y: 50 }, { opacity: 1, y: 0, ease: 'none', duration: .18 }, .38)
    .to('#heroLine2', { opacity: 0, y: -40, ease: 'none', duration: .16 }, .72)
    .to('.hero-stamp', { opacity: 0, duration: .1 }, .8);
  $$('.ridge').forEach(r => gsap.to(r, { yPercent: -(+r.dataset.ridge), ease: 'none', scrollTrigger: pin }));
  gsap.to('.sky', { scale: 1.07, ease: 'none', scrollTrigger: pin });

  /* video scrub: stream directly off the CDN (it supports byte ranges, so seeks work
     without downloading all 19MB first — critical on phones), lerped currentTime */
  const heroVid = $('#heroVid');
  let heroVidReady = false, vidTarget = 0;
  if (heroVid && window.RW_HERO){
    heroVid.addEventListener('loadedmetadata', () => {
      heroVidReady = true;
      $('#hero').classList.add('has-vid');
      try{ heroVid.currentTime = 0.001; }catch(e){}   /* force first-frame paint on iOS */
      ScrollTrigger.create({ ...pin, onUpdate: s => { vidTarget = s.progress * (heroVid.duration || 0); } });
      ScrollTrigger.refresh();
    });
    heroVid.src = window.RW_HERO;
    heroVid.load();
    (function scrubTick(){
      if (heroVidReady && heroVid.duration){
        const cu = heroVid.currentTime, d = vidTarget - cu;
        if (Math.abs(d) > 0.02) heroVid.currentTime = cu + d * 0.22;
      }
      requestAnimationFrame(scrubTick);
    })();
  }

  /* chapters */
  const CH = window.RW_CHAPTERS || [];
  let curCh = -1;
  function setChapter(i){
    if (i === curCh || !CH[i]) return;
    const first = curCh === -1; curCh = i;
    const C = CH[i];
    $$('.ch-bg').forEach(el => el.classList.remove('active'));
    const bg = $('#' + C.bg); if (bg) bg.classList.add('active');
    $$('#chRail b').forEach((b, bi) => b.classList.toggle('on', bi === i));
    const swap = () => {
      $('#chNum').textContent = C.num;
      $('#chWord').textContent = C.word;
      $('#chLine').textContent = C.line;
      $('#chProdImg').src = C.img;
      $('#chProdT').textContent = C.t;
      $('#chProdP').textContent = C.p;
      $('#chProd').setAttribute('href', C.u);
    };
    if (first){ swap(); return; }
    gsap.timeline()
      .to('#chCopy', { y: 26, opacity: 0, duration: .28, ease: 'power2.in' })
      .add(swap)
      .to('#chCopy', { y: 0, opacity: 1, duration: .55, ease: 'expo.out' });
  }
  setChapter(0);
  const el = $('#chapters');
  if (el){
    const drive = prog => setChapter(Math.max(0, Math.min(3, Math.floor(prog * 4.0001))));
    ScrollTrigger.create({ trigger: el, start: 'top top', end: 'bottom bottom', onUpdate: self => drive(self.progress) });
    $$('#chRail b').forEach((b, i) => {
      b.onclick = () => {
        const top = el.getBoundingClientRect().top + scrollY;
        lenis.scrollTo(top + (el.offsetHeight - innerHeight) * ((i + 0.5) / 4), { duration: 0.9 });
      };
    });
    const nativeDrive = () => {
      const r = el.getBoundingClientRect();
      if (r.height > innerHeight && r.top <= 0 && r.bottom >= innerHeight * .5){
        drive(Math.min(.999, -r.top / (r.height - innerHeight)));
      }
    };
    addEventListener('scroll', nativeDrive, { passive: true });
    nativeDrive();
  }

  /* favorites row drag */
  const row = $('#favRow');
  if (row){
    const fl = $('#favL'), fr = $('#favR');
    if (fl) fl.onclick = () => row.scrollBy({ left: -360, behavior: 'smooth' });
    if (fr) fr.onclick = () => row.scrollBy({ left: 360, behavior: 'smooth' });
    let drag = null;
    row.onpointerdown = e => { drag = { x: e.clientX, s: row.scrollLeft }; row.classList.add('dragging'); };
    addEventListener('pointermove', e => { if (drag) row.scrollLeft = drag.s - (e.clientX - drag.x); });
    addEventListener('pointerup', () => { drag = null; row.classList.remove('dragging'); });
  }

  /* embers */
  const cv = $('#embers');
  if (cv){
    const cx2 = cv.getContext('2d');
    let W, H; const embers = [];
    const sizeCv = () => { W = cv.width = cv.offsetWidth || innerWidth; H = cv.height = cv.offsetHeight || innerHeight; };
    sizeCv(); addEventListener('resize', sizeCv);
    for (let i = 0; i < 26; i++) embers.push({ x: Math.random(), y: Math.random(), r: .6 + Math.random()*1.8, s: .12 + Math.random()*.4, o: .2 + Math.random()*.55, w: Math.random()*Math.PI*2 });
    (function tickEmbers(){
      if (W && H){
        cx2.clearRect(0, 0, W, H);
        for (const em of embers){
          em.y -= em.s/H*1.9; em.w += .015; em.x += Math.sin(em.w)*.0004;
          if (em.y < -0.02){ em.y = 1.02; em.x = Math.random(); }
          const flick = .75 + Math.sin(em.w*3)*.25;
          cx2.beginPath(); cx2.arc(em.x*W, em.y*H, em.r, 0, 7);
          cx2.fillStyle = 'rgba(242,117,31,' + (em.o*flick) + ')'; cx2.fill();
        }
      }
      requestAnimationFrame(tickEmbers);
    })();
  }

  /* loader + hero intro */
  let heroPlayed = false;
  function heroIn(){
    if (heroPlayed) return; heroPlayed = true;
    try{
      const split = new SplitText('#heroH', { type: 'words', wordsClass: 'w' });
      gsap.timeline()
        .from('.hero-c .eyebrow', { y: 20, opacity: 0, duration: .7, ease: 'expo.out' })
        .from(split.words, { yPercent: 110, opacity: 0, filter: 'blur(10px)', duration: .9, stagger: .07, ease: 'expo.out' }, '-=.4')
        .from('#heroSub', { y: 30, opacity: 0, duration: .8, ease: 'expo.out' }, '-=.5')
        .from('#heroCta .btn', { y: 24, opacity: 0, duration: .7, stagger: .1, ease: 'expo.out' }, '-=.55')
        .from('.hero-stamp', { scale: 0, rotate: -90, opacity: 0, duration: .8, ease: 'back.out(1.6)' }, '-=.5');
    }catch(e){}
  }
  const loader = $('#loader');
  if (loader){
    gsap.timeline()
      .to('#loader img', { opacity: 1, scale: 1, rotate: 0, duration: .9, ease: 'expo.out' })
      .to('#loader .bar i', { scaleX: 1, duration: .9, ease: 'power2.inOut' }, '-=.4')
      .add(() => { loader.classList.add('done'); heroIn(); })
      .set(loader, { display: 'none', delay: 1 });
    loader.addEventListener('click', () => { loader.classList.add('done'); heroIn(); });
  } else heroIn();

  if (location.hash === '#proven'){
    setTimeout(() => { const p = $('#proven'); if (p) lenis.scrollTo(p, { offset: 0 }); }, 300);
  }
}

/* ================= PRODUCT PAGE ================= */
/* one price renderer for every JS-built card, so the related grid and the
   recently-viewed grid carry the same struck-through compare-at price and
   orange percent badge as the Liquid-rendered cards everywhere else */
function priceHtml(price, compareAt){
  price = +price || 0; compareAt = +compareAt || 0;
  if (!(compareAt > price)) return money(price);
  const pct = Math.round((compareAt - price) / compareAt * 100);
  return '<s>' + money(compareAt) + '</s>' + money(price)
    + (pct >= 5 ? '<span class="badge">-' + pct + '%</span>' : '');
}
function initProduct(){
  const P = window.RW_PRODUCT; if (!P) return;
  const q = $('#pdpQ');
  const mi = $('#pdpMinus'), pl = $('#pdpPlus');
  if (mi) mi.onclick = () => { q.textContent = Math.max(1, +q.textContent - 1); };
  if (pl) pl.onclick = () => { q.textContent = +q.textContent + 1; };
  /* ===== GALLERY =====
     A scroll-snap track of real slides: mobile swipes natively, desktop gets
     arrows + keyboard, thumbs stay in sync, and any slide opens full screen.
     Nothing swaps an img src, so there is no srcset-vs-src conflict to break. */
  const track = $('#galTrack');
  const slides = track ? Array.from(track.querySelectorAll('.gal-slide')) : [];
  const thumbs = $$('#pdpThumbs .pth');
  const galIdx = $('#galIdx'), galPrev = $('#galPrev'), galNext = $('#galNext');
  let gi = 0, snapping = false;

  /* Centre the active thumb by scrolling ONLY the strip. scrollIntoView was
     scrolling the whole document (block:'nearest' still walks up to the page
     when the strip is partly off-screen) and fought Lenis, which read on
     desktop as the page jumping up or down on every arrow click. */
  const thumbWrap = $('#pdpThumbs');
  function revealThumb(i){
    const at = thumbs[i];
    if (!thumbWrap || !at) return;
    const target = at.offsetLeft - thumbWrap.offsetLeft - (thumbWrap.clientWidth - at.clientWidth) / 2;
    const max = thumbWrap.scrollWidth - thumbWrap.clientWidth;
    thumbWrap.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: 'smooth' });
  }
  function paintGallery(i){
    gi = i;
    if (galIdx) galIdx.textContent = i + 1;
    thumbs.forEach((t, ti) => t.classList.toggle('on', ti === i));
    revealThumb(i);
    if (galPrev) galPrev.disabled = i <= 0;
    if (galNext) galNext.disabled = i >= slides.length - 1;
  }
  function goTo(i, smooth){
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    snapping = true;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    paintGallery(i);
    setTimeout(() => { snapping = false; }, 420);
  }
  if (track && slides.length){
    paintGallery(0);
    /* keep state honest when the user swipes instead of using the controls.
       Debounced on a timer rather than requestAnimationFrame: rAF is frozen in
       background/hidden tabs, which would leave the counter and thumbs stuck. */
    let syncT;
    track.addEventListener('scroll', () => {
      if (snapping) return;
      clearTimeout(syncT);
      syncT = setTimeout(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== gi && slides[i]) paintGallery(i);
      }, 90);
    }, { passive: true });
    if (galPrev) galPrev.onclick = () => goTo(gi - 1);
    if (galNext) galNext.onclick = () => goTo(gi + 1);
    thumbs.forEach(t => t.addEventListener('click', () => goTo(+t.dataset.i)));
    addEventListener('resize', () => goTo(gi, false), { passive: true });
    addEventListener('keydown', e => {
      if (/input|textarea|select/i.test(document.activeElement.tagName)) return;
      if ($('#srch') && $('#srch').classList.contains('show')) return;
      if (lb && lb.classList.contains('show')) return;      /* viewer owns the keys */
      if (e.key === 'ArrowLeft'){ e.preventDefault(); goTo(gi - 1); }
      else if (e.key === 'ArrowRight'){ e.preventDefault(); goTo(gi + 1); }
    });
  }

  /* full-screen viewer, built once on first use */
  let lb = null;
  function openLightbox(i){
    if (!slides.length) return;
    if (!lb){
      lb = document.createElement('div');
      lb.id = 'galLB';
      lb.innerHTML = '<button class="lb-x" aria-label="Close">&#10005;</button>'
        + '<button class="lb-nav prev" aria-label="Previous photo">&#8249;</button>'
        + '<img alt=""><button class="lb-nav next" aria-label="Next photo">&#8250;</button>'
        + '<div class="lb-count"></div>';
      document.body.appendChild(lb);
      lb.querySelector('.lb-x').onclick = closeLightbox;
      lb.querySelector('.lb-nav.prev').onclick = e => { e.stopPropagation(); showLB(lbI - 1); };
      lb.querySelector('.lb-nav.next').onclick = e => { e.stopPropagation(); showLB(lbI + 1); };
      lb.addEventListener('click', e => { if (e.target === lb) closeLightbox(); });
      addEventListener('keydown', e => {
        if (!lb || !lb.classList.contains('show')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showLB(lbI - 1);
        if (e.key === 'ArrowRight') showLB(lbI + 1);
      });
    }
    showLB(i);
    lb.classList.add('show');
    /* pad by exactly the scrollbar width, otherwise hiding overflow reclaims
       ~15px and the whole page slides sideways as the viewer opens */
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
    if (lenis && lenis.stop) try{ lenis.stop(); }catch(e){}
  }
  let lbI = 0;
  function showLB(i){
    lbI = Math.max(0, Math.min(slides.length - 1, i));
    const src = slides[lbI].querySelector('img');
    lb.querySelector('img').src = src.dataset.full || src.currentSrc || src.src;
    lb.querySelector('.lb-count').textContent = (lbI + 1) + ' / ' + slides.length;
    lb.querySelector('.lb-nav.prev').disabled = lbI <= 0;
    lb.querySelector('.lb-nav.next').disabled = lbI >= slides.length - 1;
  }
  function closeLightbox(){
    if (!lb) return;
    lb.classList.remove('show');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (lenis && lenis.start) try{ lenis.start(); }catch(e){}
    goTo(lbI, false);   /* leave the inline gallery on whatever they were looking at */
  }
  const galZoom = $('#galZoom');
  if (galZoom) galZoom.onclick = () => openLightbox(gi);
  slides.forEach((s, i) => s.querySelector('img').addEventListener('click', () => openLightbox(i)));
  /* variant picker: keep every add button, the express-checkout form, AND every
     visible price pointed at the chosen variant. The displayed price must always
     equal what lands in the cart — anything else is a bait-and-switch at the ATC. */
  function paintPrice(p, cap){
    const el = $('#pdpPrice');
    if (el && p){
      let html = '';
      if (cap > p) html += '<s>' + money(cap) + '</s>';
      html += money(p);
      if (cap > p) html += ' <span class="badge">SAVE ' + Math.round((cap - p) / cap * 100) + '%</span>';
      el.innerHTML = html;
    }
    const sp = $('#sbPrice'); if (sp && p) sp.textContent = money(p);
  }
  const varSel = $('#pdpVar');
  if (varSel) varSel.addEventListener('change', () => {
    const vid = varSel.value;
    const add = $('#pdpAdd'); if (add) add.dataset.vid = vid;
    const sb = $('#sbBtn'); if (sb) sb.dataset.vid = vid;
    const f = $('#pdpFormVid'); if (f) f.value = vid;
    P.vid = vid;
    const opt = varSel.options[varSel.selectedIndex];
    if (opt){
      /* jump the slider to that variant's photo instead of swapping a src */
      if (opt.dataset.img && slides.length){
        const key = (opt.dataset.img.split('?')[0] || '').split('/').pop();
        const hit = slides.findIndex(s => (s.querySelector('img').src || '').indexOf(key) > -1);
        if (hit > -1) goTo(hit);
      }
      const np = +opt.dataset.p, ncap = +opt.dataset.cap || 0;
      if (np){ P.p = np; paintPrice(np, ncap); }
    }
  });
  /* star badge is a shortcut to the proof */
  document.addEventListener('click', e => {
    const b = e.target.closest('.jdgm-preview-badge'); if (!b) return;
    const band = document.querySelector('.reviews-band');
    if (band) lenis.scrollTo(band, { offset: -80 });
  });
  /* sticky bar */
  const sbI = $('#sbImg'), sbT = $('#sbTitle'), sbP = $('#sbPrice'), sbB = $('#sbBtn');
  if (sbI){ sbI.src = (P.img || '').replace('width=400', 'width=120') || P.img; sbT.textContent = P.t; sbP.textContent = money(P.p); sbB.dataset.vid = P.vid; }
  /* honest dispatch + delivery promise */
  const d = $('#dispatch');
  if (d){
    const now = new Date(), cut = new Date(now); cut.setHours(14, 0, 0, 0);
    const wd = now.getDay();
    const sameDay = wd >= 1 && wd <= 5 && now < cut;
    const ship = new Date(now);
    if (!sameDay){ do { ship.setDate(ship.getDate() + 1); } while (ship.getDay() === 0 || ship.getDay() === 6); }
    /* promise a RANGE, not a single date — the single date overcommitted vs the
       3-7 business day shipping policy and buyer-timezone math */
    const etaMin = new Date(ship); etaMin.setDate(etaMin.getDate() + 4);
    const etaMax = new Date(ship); etaMax.setDate(etaMax.getDate() + 8);
    const fmt = x => x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const lead = sameDay
      ? (() => { const m = Math.round((cut - now)/60000); return 'Order in <b>' + Math.floor(m/60) + 'h ' + (m%60) + 'm</b> and it ships today'; })()
      : 'Ships the <b>next business day</b>';
    d.innerHTML = lead + ' · get it <b>' + fmt(etaMin) + ' to ' + fmt(etaMax) + '</b> · $8 flat U.S. shipping, FREE over $75';
  }
  /* related grid via native recommendations (the pairs box is server-rendered, cross-category) */
  fetch('/recommendations/products.json?product_id=' + P.id + '&limit=6')
    .then(r => r.json())
    .then(data => {
      const recs = (data.products || []).filter(p => p.id !== P.id);
      const rel = recs.slice(0, 4), rg = $('#relGrid');
      if (rel.length && rg){
        const sized = (u, w) => u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
        rg.innerHTML = rel.map(p => `<a class="pc" href="/products/${p.handle}">
          <button class="qadd" data-vid="${p.variants && p.variants[0] && p.variants[0].id}" aria-label="Quick add">+</button>
          <div class="im"><img src="${sized(p.featured_image, 400)}" loading="lazy" alt=""></div>
          <div class="in"><div class="type">${p.type || ''}</div><div class="t">${p.title}</div>
          <div class="price">${priceHtml(p.price, p.compare_at_price)}</div></div></a>`).join('');
        initTilt();
      }
    }).catch(() => {});
  /* recently viewed */
  let rv = []; try{ rv = JSON.parse(localStorage.getItem('rw_recent2') || '[]'); }catch(e){}
  const show = rv.filter(x => x.handle !== P.handle).slice(0, 4);
  rv = [P, ...rv.filter(x => x.handle !== P.handle)].slice(0, 8);
  try{ localStorage.setItem('rw_recent2', JSON.stringify(rv)); }catch(e){}
  const rw = $('#recentWrap');
  if (rw && show.length){
    rw.style.display = '';
    /* p.cap is the compare-at price; entries saved before this shipped simply
       have none and fall back to a plain price */
    $('#recentGrid').innerHTML = show.map(p => `<a class="pc" href="${p.u}">
      <div class="im"><img src="${p.img}" loading="lazy" alt=""></div>
      <div class="in"><div class="t">${p.t}</div><div class="price">${priceHtml(p.p, p.cap)}</div></div></a>`).join('');
  }
}

/* ================= BOOT ================= */
/* each init is isolated: an animation failure must never take the cart down with it */
try{ initHome(); }catch(e){}
try{ initProduct(); }catch(e){}
try{ initReveals(document); }catch(e){}
try{ initMagnetic(); }catch(e){}
try{ initTilt(); }catch(e){}
try{ ScrollTrigger.refresh(); }catch(e){}
/* newsletter forms reload the page with ?customer_posted=true — confirm it */
if (location.search.indexOf('customer_posted=true') > -1){
  setTimeout(() => toast('Welcome to base camp. TRAIL10 is yours.'), 600);
}
})();
